import React, { useState } from 'react';
import { Accordion, Card, Container } from 'react-bootstrap';
import { ChevronDown, ChevronUp } from 'lucide-react';
import '../css/Faq.css';

const defaultFaqs = [
  {
    question: 'How do I make a booking?',
    answer:
      'To make a booking, select your desired room, choose check-in and check-out dates, add any extras, and complete the payment process securely on our site.',
  },
  {
    question: 'What is the cancellation policy?',
    answer:
      'You can cancel free of charge up to 24 hours before your scheduled arrival. Cancellations made within 24 hours of check-in may incur a fee.',
  },
  // {
  //   question: 'Is breakfast included in the room rate?',
  //   answer:
  //     'Breakfast inclusion depends on the rate plan you select. Please check the room details when booking or contact us for a customized package.',
  // },
  {
    question: 'Can I request an early check-in or late check-out?',
    answer:
      'Early check-in and late check-out are subject to availability and may incur an additional charge. Please get in touch with our front desk after booking.',
  },
  {
    question: 'Are pets allowed in the rooms?',
    answer:
      'We offer select pet-friendly rooms. Please filter by pet-friendly option when booking or contact us directly to arrange a stay for your furry friend.',
  },
];

const Faq = ({ faqs = defaultFaqs }) => {
  const [activeKey, setActiveKey] = useState(null);

  const toggleActive = key => {
    setActiveKey(prevKey => (prevKey === key ? null : key));
  };

  return (
    <section className="faq-section py-5 bg-white">
      <Container>
        <h2 className="faq-title text-center mb-4">Frequently Asked Questions</h2>
        <Accordion activeKey={activeKey} className="faq-accordion">
          {faqs.map((item, idx) => {
            const eventKey = String(idx);
            const isActive = activeKey === eventKey;
            return (
              <Card key={eventKey} className="faq-card mb-3">
                <Accordion.Item eventKey={eventKey}>
                  <Accordion.Header onClick={() => toggleActive(eventKey)}>
                   
                    <span className="faq-question">{item.question}</span>
                  </Accordion.Header>
                  <Accordion.Body className={`faq-answer ${isActive ? 'active' : ''}`}>
                    {item.answer}
                  </Accordion.Body>
                </Accordion.Item>
              </Card>
            );
          })}
        </Accordion>
      </Container>
    </section>
  );
};

export default Faq;
